import React from 'react'
import icons from './../../../utils/import.icons'
import mobileAndTabletCheck from './../../../utils/mobileCheck'
import { AmenidadesData as AData_1} from './amenidades-atlantica.data.js'
import { AmenidadesData as AData_2} from './amenidades-oceana.data.js'
import { AmenidadesData as AData_3} from './amenidades-mediterranea'

import { ContextLoader } from "./../../../utils/import.frames";

let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 0;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

let Amenities: any = []

let amenitiess = []

interface Billboards{
    billboard: any,
    BData: any,
    billboards: any
}

interface Props{
    amenity: any,
    projectSelected: any,
    angle: number,
    gallery: any,
    openGallery: any, 
    show: boolean,
    leftOffset: number,
    zoom: number,
    topOffset: number,
    currentProject: string,
    handleOpenSpin: any
}

interface State{
    angle: number,
    pos: any,
    transition: boolean
}

interface Links {
    data?: any,
    ContextLoader: any
}

class Billboards extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            angle: 0,
            pos: [],
            transition: false
        }
    }

    componentDidMount(){

        this.billboard = <div></div>

        this.BData = {
            'Antao': AData_1(),
            'Porto Novo': AData_3(),
        }

        this.billboards = this.BData['Antao']
        this.billboards = this.BData['Porto Novo']
    }

    createBillboards = () => {

        const data: Links = {ContextLoader}
        
        if(this.props.amenity.Nombre !== ''){
            
            if(this.billboards[this.props.angle] && this.billboards[this.props.angle < 0 ? 0: this.props.angle].length > 0 ){
                
                this.billboard = <div></div>
                for(let i = 0; i < this.billboards[this.props.angle].length; i++)
                {
                    if(this.billboards[this.props.angle][i].name === this.props.amenity.Nombre){
                        /*this.setState(prevState => ({
                            pos: this.billboards[this.props.angle][i].pos
                        }), 
                        () => {*/
                        this.billboard = <svg 
                        width={"100%"}
                        height={"100%"}
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 1080"
                        style={{
                            overflow: 'hidden',
                            pointerEvents: 'none',
                            position: 'absolute'
                        }}>
                            <g style={{
                                pointerEvents: this.props.show ? 'visibleFill':'none'
                            }}
                            onClick = {data.ContextLoader[this.props.amenity.Nombre + " " + this.props.projectSelected] ? () => {this.props.handleOpenSpin(this.props.amenity.Nombre)} : this.props.gallery.length > 0 ? this.props.openGallery:null}
                            onTouchStart = {data.ContextLoader[this.props.amenity.Nombre + " " + this.props.projectSelected] ? () => {this.props.handleOpenSpin(this.props.amenity.Nombre)} : this.props.gallery.length > 0 ? this.props.openGallery:null}
                            >
                            <line
                            x1={this.billboards[this.props.angle][i].verts[0][0]}
                            y1={ this.billboards[this.props.angle][i].verts[0][1] - 10}
                            x2={this.billboards[this.props.angle][i].verts[0][0]}
                            y2={this.billboards[this.props.angle][i].verts[0][1] - 240}
                            stroke-linecap="round"
                            stroke-dasharray="0"
                            style={{
                                stroke: "rgba(255,255,255,1)",
                                strokeWidth: 3.5
                            }}
                        />
                        <rect
                            x={this.billboards[this.props.angle][i].verts[0][0] - 65}
                            y={this.billboards[this.props.angle][i].verts[0][1] - 280}
                            width={this.props.amenity.Nombre.length > 10? "142": "130"}
                            height="60"
                            // r="30" 
                            style={{
                                fill: "rgba(77,53,255,.85)",
                                stroke: "rgba(255,255,255,.85)",
                                strokeWidth: 0.8,
                            }}
                        />
                        <rect className={this.props.amenity.Nombre === "Portería 1" || this.props.amenity.Nombre === "Salón Comunal"? 'content-text': 'fade-out'} rx="10" ry="10"  x={this.billboards[this.props.angle][i].verts[0][0]-110}
                        y={this.billboards[this.props.angle][i].verts[0][1]-320} width="11%" height="2.5%" style={{fill:"rgba(70,113,197,1)"}} />
                            
                                <foreignObject 
                                    width={this.props.amenity.Nombre.length > 10? "142": "130"} 
                                    height="60" 
                                    x={this.billboards[this.props.angle][i].verts[0][0] - 65}
                                    y={this.billboards[this.props.angle][i].verts[0][1] - 280}
                                    requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
                                    style={{position:"fixed"}}
                                    >
                                    <body>
                                        <p style={{
                                            wordBreak: "break-word",
                                            whiteSpace: "normal",
                                            width: "100%",
                                            textAlign: "center",
                                            color: "white",
                                            fontFamily: "Montserrat Regular",
                                            position:"fixed",
                                            top:"50%",
                                            transform:"translate(0,-50%)"
                                            }} >{this.props.amenity.Nombre}</p>
                                    </body>
                                </foreignObject>
                            </g>
                            
                        </svg>;
                            
                        //})
                        break;
                    }                    
                }
            } 
            else
            {
                this.billboard = <div></div>
            }
            
        }
    }

    componentDidUpdate(prevProps: any){

        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 5;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
          imageSize = ['100%', '100%'];
          barOffset = 0;
        }

        this.updateBDataRef();
  
        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 

        if(prevProps.amenity !== this.props.amenity){
            this.setState({transition:true})
            setTimeout(function(this: any){
                this.setState({
                    transition: false,
                })
                this.createBillboards();
                this.forceUpdate();   
            }.bind(this), 250)
        }
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show){
            //console.log(this.props)
            this.createBillboards();
            this.forceUpdate();        
        }
    }

    updateBDataRef = () => {
        if(this.props.currentProject !== ''){
            this.billboards = this.BData[this.props.currentProject];
        } else {
            return false;
        }
        return true
    }
  
    render() {
        return (
            <div
                style={{
                    pointerEvents: 'none',
                    width: imageSize[0],
                    height: imageSize[1],
                    //transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc(' + barOffset + '% + ' + this.props.topOffset + '%))'
                }}
                className={this.props.show && !this.state.transition ? "billboards fade-in":"billboards fade-out"}
            >
                {this.billboard}
            </div>
            
        );
      
    }

}

export default Billboards